import { Component, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { resolveKioskPhotoUrl } from 'src/app/secure/components/suspect-image/suspect-image.component';
import { UiModule } from '../../../../components/ui.module';
import { TheftReportAttachmentType } from '../../../../types';

type CellParams = ICellRendererParams;

@Component({
  selector: 'app-pan-cell-theft-report-photo',
  imports: [UiModule, MatTooltipModule, RouterModule, MatIcon],
  templateUrl: './cell-theft-report-photo.component.html',
  styleUrl: './cell-theft-report-photo.component.scss',
})
export class CellTheftReportPhotoComponent implements ICellRendererAngularComp {
  public photoLink = signal<string>('');
  public isLoading = signal<boolean>(true);
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
    this.resolvePhotoUrl().then((url) => this.photoLink.set(url));
  }

  refresh(params: CellParams) {
    this.params = params;
    this.resolvePhotoUrl().then((url) => this.photoLink.set(url));
    return true;
  }

  async resolvePhotoUrl() {
    if (this.params.data.use_kiosk_photo && this.params.data.image_id) {
      const url = await resolveKioskPhotoUrl(this.params.data.image_id);
      this.isLoading.set(false);
      return url;
    }
    this.isLoading.set(false);
    return this.params.data.attachments?.find((a) => a.type === TheftReportAttachmentType.InstancePhoto)?.content ?? '';
  }
}
